import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'name',
		title: 'global.name',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'producerName',
		title: 'global.producer',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'projectName',
		title: 'global.project',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'meterPointsCount',
		title: 'global.meterpointCount',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'minValueConverted',
		title: 'sites.minValueProduction',
		defaultVisible: true,
	},
	{
		accessor: 'maxValueConverted',
		title: 'sites.maxValueProduction',
		defaultVisible: true,
	},
	{
		accessor: 'lastConversionFactor',
		title: 'sites.lastConversionFactor',
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'place',
		title: 'global.place',
		type: 'shortText',
		defaultVisible: false,
	},
	{
		accessor: 'organizationName',
		title: 'global.organization',
		type: 'shortText',
		defaultVisible: false,
		sortable: true,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		type: 'shortText',
		defaultVisible: false,
		sortable: true,
	},
	{
		type: 'sitesActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
